/* global localStorage:false, swal:false */
;(function () {
  'use strict'

  angular.module('users.service', []).factory('UsersService', UsersService)

  /** @ngInject */
  function UsersService($http, $q, API) {
    function me(userId, model) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'admin/users/' + userId, model).success(defer.resolve)

      return defer.promise
    }

    function birthday(userId, model) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'admin/users/' + userId + '/birthday', model).success(defer.resolve)

      return defer.promise
    }

    function phone(userId) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + userId + '/phone')
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function lockUser(userId, model) {
      var defer = $q.defer()

      $http.put(API.API_URL + 'admin/users/' + userId + '/lock', model).success(defer.resolve)

      return defer.promise
    }

    function resetKYC(userId) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'admin/users/' + userId + '/kyc/reset').success(defer.resolve)

      return defer.promise
    }

    function approveKYC(userId, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + userId + '/kyc/approve', model)
        .success(defer.resolve)

      return defer.promise
    }

    function tos(userId, model) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'users/' + userId + '/consent', model).success(defer.resolve)

      return defer.promise
    }

    function unlockUser(userId, model) {
      var defer = $q.defer()

      $http.put(API.API_URL + 'admin/users/' + userId + '/unlock', model).success(defer.resolve)

      return defer.promise
    }

    function signin(model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'users/signin', model)
        .success(defer.resolve)
        .error(function () {
          swal('User or password wrong!', '', 'error')
        })

      return defer.promise
    }

    function signup(model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'users', model)
        .success(defer.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defer.promise
    }

    function update(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id, model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function remove(id) {
      var defer = $q.defer()

      $http
        .delete(API.API_URL + 'admin/users/' + id)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function get(id) {
      var defer = $q.defer()
      $http.get(API.API_URL + 'admin/users/' + id).success(defer.resolve)

      return defer.promise
    }

    function getUser() {
      var defer = $q.defer()
      var user = JSON.parse(localStorage.getItem('user'))
      $http.get(API.API_URL + 'users/' + user.id).success(defer.resolve)

      return defer.promise
    }

    function saveUser(model) {
      var defer = $q.defer()
      var user = JSON.parse(localStorage.getItem('user'))
      model.id = parseInt(user.id)
      $http.post(API.API_URL + 'users/update', model).success(defer.resolve)

      return defer.promise
    }

    function updateUser(model) {
      var defer = $q.defer()
      $http.post(API.API_URL + 'users/update', model).success(defer.resolve)

      return defer.promise
    }

    function getAll(start, limit) {
      var defer = $q.defer()
      $http
        .get(API.API_URL + 'admin/users?start=' + start + '&limit=' + limit)
        .success(defer.resolve)

      return defer.promise
    }

    function addCoins(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/giveout', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function addCash(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/cash/giveout', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function addStoreCredit(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/store_credit/giveout', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function report(id) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'admin/users/' + id + '/report').success(defer.resolve)

      return defer.promise
    }

    function clearReport(id) {
      var defer = $q.defer()

      $http.delete(API.API_URL + 'admin/users/' + id + '/reports').success(defer.resolve)

      return defer.promise
    }

    function remove2fa(id) {
      var defer = $q.defer()

      $http.delete(API.API_URL + 'admin/users/' + id + '/2fa').success(defer.resolve)

      return defer.promise
    }

    function search(name, sort, start, limit) {
      var defer = $q.defer()

      name = encodeURIComponent(name)

      $http
        .get(
          API.API_URL +
            'admin/users/search/prefix?username=' +
            name +
            '&sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function searchEmail(email, sort, start, limit) {
      var defer = $q.defer()

      email = encodeURIComponent(email)

      $http
        .get(
          API.API_URL +
            'admin/users/search/prefix?email=' +
            email +
            '&sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function searchUsernameChange(username, sort, start, limit) {
      var defer = $q.defer()

      username = encodeURIComponent(username)

      $http
        .get(
          API.API_URL +
            'admin/users/search/prefix?username_changes=' +
            username +
            '&sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function searchEmailChange(email, sort, start, limit) {
      var defer = $q.defer()

      email = encodeURIComponent(email)

      $http
        .get(
          API.API_URL +
            'admin/users/search/prefix?email_changes=' +
            email +
            '&sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function searchPhone(phone, sort, start, limit) {
      var defer = $q.defer()

      phone = encodeURIComponent(phone)

      $http
        .get(
          API.API_URL +
            'admin/users/search?phone=' +
            phone +
            '&sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function block(id, model) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'admin/users/' + id + '/block', model).success(defer.resolve)

      return defer.promise
    }

    function unblock(id) {
      var defer = $q.defer()

      $http.delete(API.API_URL + 'admin/users/' + id + '/block').success(defer.resolve)

      return defer.promise
    }

    function listReports(id, sort) {
      var defer = $q.defer()

      $http.get(API.API_URL + 'admin/users/' + id + '/reports?sort=' + sort).success(defer.resolve)

      return defer.promise
    }

    function listAllReports(start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL + 'admin/users/reports?start=' + start + '&limit=' + limit + '&sort=' + sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listComments(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/comments?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listFavotireChannels(id, sort) {
      var defer = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/' + id + '/channels/favorite?sort=' + sort)
        .success(defer.resolve)

      return defer.promise
    }

    function listChatMessages(id, start, limit, sort, username) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/chats?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort +
            '&username=' +
            username,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listTradeMessages(id, start, limit, sort, username) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/trade_chats?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort +
            '&username=' +
            username,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listChatsMessages(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/chats/' +
            id +
            '/messages?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listFriends(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/friendships?sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listTrades(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/trades?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listTradesByStatus(id, start, limit, sort, st) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/trades?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort +
            '&st=' +
            st,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listListingSeller(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/listings/seller?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listListingBuyer(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/listings/buyer?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function usernameAvailable(username) {
      var defer = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/username_available?username=' + username)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function changeUsername(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/username', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function changeEmail(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/email', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function changePhone(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/phone', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function changePassword(id, model) {
      var defer = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/password', model)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function listPurchaseLogs(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL + 'admin/users/' + id + '/purchase_logs?start=' + start + '&limit=' + limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listDevices(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/signin_devices?sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listItemsExplorer(id, chId, start, limit) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/prints?start=' +
            start +
            '&limit=' +
            limit +
            '&channelId=' +
            chId,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listCollection(id) {
      var defer = $q.defer()

      $http.get(API.API_URL + 'admin/users/' + id + '/collection_value').success(defer.resolve)

      return defer.promise
    }

    function listIPs(ip_address) {
      var defer = $q.defer()

      $http.get(API.API_URL + 'admin/users/for_ip/' + ip_address).success(defer.resolve)

      return defer.promise
    }

    function listInviters(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/inviter?sort=' +
            sort +
            '&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function clearDevices(id) {
      var defer = $q.defer()

      $http.delete(API.API_URL + 'admin/users/' + id + '/signin_devices').success(defer.resolve)

      return defer.promise
    }

    function deleteDevice(userId, id) {
      var defer = $q.defer()

      $http
        .delete(API.API_URL + 'admin/users/' + userId + '/signin_devices/' + id)
        .success(defer.resolve)

      return defer.promise
    }

    function listLedgers(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/ledgers?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listLedgersFlow(id, type, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/ledgers?flow=' +
            type +
            '&start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listLedgersFilter(id, type, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/ledgers?k=' +
            type +
            '&start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listCashLedgers(id, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/cash_ledgers?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listCashLedgersFlow(id, type, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/cash_ledgers?flow=' +
            type +
            '&start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listCashLedgersFilter(id, type, start, limit, sort) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/cash_ledgers?k=' +
            type +
            '&start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listNotes(id, start, limit) {
      var defer = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/' + id + '/user_notes?start=' + start + '&limit=' + limit)
        .success(defer.resolve)

      return defer.promise
    }

    function listNotesLimit(id) {
      var defer = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/' + id + '/user_notes?start=0&limit=10')
        .success(defer.resolve)

      return defer.promise
    }

    function createNotes(id, model) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'admin/users/' + id + '/user_notes', model).success(defer.resolve)

      return defer.promise
    }

    function deleteTradePost(id, model) {
      var defer = $q.defer()

      $http.delete(API.API_URL + 'admin/users/' + id + '/trade_posts').success(defer.resolve)

      return defer.promise
    }

    function listRestrictions(id, start, limit) {
      var defer = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/' + id + '/permissions?start=' + start + '&limit=' + limit)
        .success(defer.resolve)

      return defer.promise
    }

    function getShowcase(id) {
      var defer = $q.defer()

      $http
        .get(API.API_URL + 'users/' + id + '/print_lists/showcases/active')
        .success(defer.resolve)

      return defer.promise
    }

    function addShowcase(model) {
      var defer = $q.defer()

      $http.post(API.API_URL + 'print_lists', model).success(defer.resolve)

      return defer.promise
    }

    function deleteShowcase(id) {
      var defer = $q.defer()

      $http
        .delete(API.API_URL + 'admin/print_lists/' + id)
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function verify(id) {
      var defer = $q.defer()

      $http
        .put(API.API_URL + 'admin/users/' + id + '/verify')
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function verifyEmail(id) {
      var defer = $q.defer()

      $http
        .put(API.API_URL + 'admin/users/' + id + '/email_verify')
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function listShowcases(id, start, limit) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/print_lists/showcases?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=a-desc',
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listPromoCodes(id, start, limit) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/promo_codes/redeemed?start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)

      return defer.promise
    }

    function listShelfies(id, start, limit) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            id +
            '/posts/shelfies?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=pin-asc',
        )
        .success(defer.resolve)

      return defer.promise
    }

    function commentHide(id) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'admin/comments/' + id + '/hide').success(defered.resolve)

      return defered.promise
    }

    function resetRank(userId) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/' + userId + '/leaderboards/value/refresh')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function setShelfie(userId, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/users/' + userId + '/set_shelfie_featurer', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function shelfiePin(id, model) {
      var defered = $q.defer()

      $http.put(API.API_URL + 'admin/admin_posts/' + id + '/pin', model).success(defered.resolve)

      return defered.promise
    }

    function shelfiePool(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/admin_posts/' + id + '/featured', model)
        .success(defered.resolve)

      return defered.promise
    }

    function bundlePurchases(userId, id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/' + userId + '/bundle_purchases/' + id)
        .success(defered.resolve)

      return defered.promise
    }

    function listPrintEscrows(userId, start, limit) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            userId +
            '/print_escrows?start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function listPrintEscrowsTransfer(userId, start, limit) {
      var defer = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/users/' +
            userId +
            '/print_transfer_logs?start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function getShippingAddress(userId) {
      var defer = $q.defer()

      $http
        .get(API.API_URL + 'admin/users/' + userId + '/shipping_addresses')
        .success(defer.resolve)
        .error(defer.reject)

      return defer.promise
    }

    function clearBalanceCache(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/users/' + id + '/clear_balance_cache')
        .success(defered.resolve)

      return defered.promise
    }

    function getPrintPublic(id) {
      var defer = $q.defer()

      $http.get(API.API_URL + 'prints/' + id).success(defer.resolve)

      https: return defer.promise
    }

    return {
      signin: signin,
      signup: signup,
      getUser: getUser,
      remove: remove,
      saveUser: saveUser,
      getAll: getAll,
      update: update,
      me: me,
      birthday: birthday,
      phone: phone,
      lockUser: lockUser,
      unlockUser: unlockUser,
      resetKYC: resetKYC,
      approveKYC,
      tos,
      get: get,
      addCoins: addCoins,
      addCash: addCash,
      addStoreCredit: addStoreCredit,
      report: report,
      clearReport: clearReport,
      remove2fa,
      search: search,
      searchEmail: searchEmail,
      searchUsernameChange: searchUsernameChange,
      searchEmailChange: searchEmailChange,
      searchPhone: searchPhone,
      block: block,
      unblock: unblock,
      listReports: listReports,
      listComments: listComments,
      listFavotireChannels: listFavotireChannels,
      listChatMessages: listChatMessages,
      listTradeMessages: listTradeMessages,
      listFriends: listFriends,
      listTrades: listTrades,
      listTradesByStatus: listTradesByStatus,
      listListingSeller: listListingSeller,
      listListingBuyer: listListingBuyer,
      listAllReports: listAllReports,
      usernameAvailable: usernameAvailable,
      changeUsername: changeUsername,
      changeEmail: changeEmail,
      changePhone,
      listPurchaseLogs: listPurchaseLogs,
      listDevices: listDevices,
      listItemsExplorer: listItemsExplorer,
      listIPs: listIPs,
      clearDevices: clearDevices,
      deleteDevice: deleteDevice,
      listInviters: listInviters,
      listLedgers: listLedgers,
      listLedgersFilter: listLedgersFilter,
      listLedgersFlow: listLedgersFlow,
      listCashLedgers: listCashLedgers,
      listCashLedgersFilter: listCashLedgersFilter,
      listCashLedgersFlow: listCashLedgersFlow,
      listNotesLimit: listNotesLimit,
      createNotes: createNotes,
      listNotes: listNotes,
      listChatsMessages: listChatsMessages,
      deleteTradePost: deleteTradePost,
      listRestrictions: listRestrictions,
      changePassword: changePassword,
      getShowcase: getShowcase,
      addShowcase: addShowcase,
      deleteShowcase: deleteShowcase,
      verify: verify,
      verifyEmail,
      listShowcases: listShowcases,
      listPromoCodes: listPromoCodes,
      listShelfies: listShelfies,
      commentHide: commentHide,
      resetRank: resetRank,
      shelfiePin: shelfiePin,
      shelfiePool: shelfiePool,
      setShelfie: setShelfie,
      bundlePurchases: bundlePurchases,
      listCollection: listCollection,
      listPrintEscrows: listPrintEscrows,
      listPrintEscrowsTransfer: listPrintEscrowsTransfer,
      getShippingAddress: getShippingAddress,
      clearBalanceCache: clearBalanceCache,
      getPrintPublic,
    }
  }
})()
